module.exports = __webpack_public_path__ + "static/media/6.1a8cf8c9.PNG";